import React from "react";
import OuterHeader from "./../ui/outer-header";
import Footer from "./../components/footer";
import useAuth from "./../context/auth";
import {guides_data} from "../assets/data/guides";

const Guides = () => {
    const { auth } = useAuth();

    return (
        <div className="min-h-screen">
            {!auth && <OuterHeader />}

            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
                <div className="mb-10 sm:mb-14 text-center">
                    <h1 className="text-3xl sm:text-5xl font-bold dark:text-white mb-3">Guides & Tutorials</h1>
                    <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto">Learn how to use your dashboard step-by-step with simple guides and videos.</p>
                </div>

                <div className="flex flex-wrap justify-center gap-3 mb-10 bg-white/70 dark:bg-[#0d1117]/70 backdrop-blur-md py-3 rounded-xl">
                    {guides_data.map((item) => (
                        <a
                            key={item.title}
                            href={`#${item.title}`}
                            className="capitalize px-4 py-2 rounded-full text-sm bg-white/70 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-300"
                        >
                            {item.title}
                        </a>
                    ))}
                </div>

                <div className="flex flex-col gap-6">
                    {guides_data.map((item) => (
                        <div
                            key={item.title}
                            id={item.title}
                            className="rounded-2xl p-5 sm:p-8 bg-white/80 dark:bg-[#0d1117]/80 backdrop-blur-md border border-gray-100 dark:border-gray-800 shadow-[0_10px_30px_rgba(0,0,0,0.05)]"
                        >
                            <h2 className="text-xl sm:text-2xl font-semibold capitalize dark:text-white mb-2">{item.title}</h2>
                            <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed mb-4">{item.description}</p>
                            <div className="aspect-video w-full rounded-xl overflow-hidden bg-black">
                                {item.video ? (
                                    <iframe
                                        className="w-full h-full"
                                        src={item.video}
                                        title={item.description}
                                        allowFullScreen
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
                                        Video coming soon
                                    </div>
                                )}
                            </div>
                            <div className="mt-6 h-[1px] bg-gray-200 dark:bg-gray-800" />
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    );
};
export default Guides;